import { createEntityAdapter } from '@reduxjs/toolkit';
import { ChatsParams } from './chats.types';

const adapter = createEntityAdapter<ChatsParams>();

export default adapter;
